import React from 'react';
import { Text, StyleSheet, View } from 'react-native';
import Theme from '../../theme';
import { ConnectingLoaderIcon } from '../../ui/components/Icons';

export default class MonitorConnectionStatus extends React.PureComponent<any, any>  {
  public render() {
    const { statusText, statusActionText } = this.props;
    return (
      <View style={styles.container}>
        <ConnectingLoaderIcon width={50} height={50} />
        <View style={styles.loaderTextContainer}>
          <Text style={styles.statusText}>{statusText}</Text>
          <Text style={styles.statusAction}>{statusActionText}</Text>
        </View>
      </View>
    );
  }
}

const styles = StyleSheet.create({
  container: {
    flex: 1,
    flexDirection: 'row',
    justifyContent: 'center',
  },
  loaderTextContainer: {
    flexDirection: 'column',
  },
  statusAction: {
    color: Theme.BLACK,
    fontSize: 16,
    fontFamily: Theme.Custom600,
  },
  statusText: {
    color: Theme.BLACK,
    fontSize: 16,
    fontFamily: Theme.Custom500,
  }
});
